import { ValidationFields, ValidationResult, Validator } from '@/helpers/validation/Validator';
import validator_required from './types/required';
import validator_string from './types/string';
import validator_int from './types/int';
import validator_date from './types/date';

Validator.addMethod('required', validator_required);
Validator.addMethod('string', validator_string);
Validator.addMethod('int', validator_int);
Validator.addMethod('date', validator_date);

const resolvePath = (object, path, defaultValue = null) =>
    path.split('.').reduce((o, p) => (o ? o[p] : defaultValue), object);

export const validate = (required_validations: ValidationFields, input): ValidationResult => {
    const validationResult: ValidationResult = {
        success: true,
        errors: [],
    };

    Object.keys(required_validations).forEach((key) => {
        const validations_needed = required_validations[key];

        validations_needed.forEach((alias) => {
            const value = resolvePath(input, key);
            const check = Validator.validate(alias, value, key);

            // console.log('validating', alias, 'for', key, 'with', value, 'data', input, 'result', check);

            if (!check.success) {
                validationResult.success = false;

                if (check.message) {
                    validationResult.errors.push({
                        key,
                        message: check.message,
                    });
                }
            }
        });
    });

    return validationResult;
};
